import _ from 'lodash'

function TextFilterAccent(_a: any, value: string, filterText: string) {
	let val = _.deburr(value)
	let filterVal = _.deburr(filterText)
	return val.indexOf(filterVal, 0) !== -1
}

export default TextFilterAccent